import { Box } from "@mui/material";
import TabContainorMultimedia from "./TabContainorMultimedia";
import TabContainorQuestions from "./TabContainorQuestions";

const MultimediaTabContainor = ({ tabIndex, editableMultimediaData, setEditableMultimediaData, multimediaData, setMultimediaData, artists, showLoader, global_constant }) => {
    return (
        <Box sx={{
            flex: 1,
            mt: 0,
            overflowY: 'auto',
            paddingRight: 1,
            paddingLeft: 1,
            paddingBottom: 0,
            maxHeight: 'calc(100vh - 160px)', // Adjust height depending on tab + button height
        }}>
            {tabIndex === 0 && (
                <TabContainorMultimedia
                    editableMultimediaData={editableMultimediaData}
                    setEditableMultimediaData={setEditableMultimediaData}
                    multimediaData={multimediaData}
                    setMultimediaData={setMultimediaData}
                    showLoader={showLoader}
                    global_constant={global_constant}
                    artists={artists}
                />
            )}
            {tabIndex === 1 && (
                <TabContainorQuestions
                    editableMultimediaData={editableMultimediaData}
                    setEditableMultimediaData={setEditableMultimediaData}
                    multimediaData={multimediaData}
                    setMultimediaData={setMultimediaData}
                    showLoader={showLoader}
                    global_constant={global_constant} />
            )}
        </Box>
    );
}

export default MultimediaTabContainor;